<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let min = 1;
	export let max = 99;
	export let value = 1;
	export let name = "";

	function incValue() {
		if (value < max) {
			value++;
			dispatch("change", { value });
		}
	}
	function decValue() {
		if (value > min) {
			value--;
			dispatch("change", { value });
		}
	}
</script>

<div class="box">
	<button type="button" class="substract">
		<svg viewBox="0 0 15 15" on:click={decValue} class:disabled={value === min}>
			<path fill-rule="evenodd" d="M15 9H0V6h15" />
		</svg>
	</button>
	<div class="value">{value} {name}{value > 1 ? 's' : ''}</div>
	<button type="button" class="substract">
		<svg viewBox="0 0 15 15" on:click={incValue} class:disabled={value === max}>
			<path fill-rule="evenodd" d="M9 6h6v3H9v6H6V9H0V6h6V0h3" />
		</svg>
	</button>
</div>

<style>
	.box {
		display: flex;
	}
	.substract {
		position: static;
		flex-shrink: 0;

		width: 3.1rem;
		height: 3.1rem;
		border-radius: 50%;
		text-align: center;
		padding: 0;
		border: none;
		outline: none;
		background: transparent;
		cursor: pointer;
		transition: all 0.2s ease-in-out;
		line-height: 0;
	}
	.value {
		line-height: 3.1rem;
	}
	svg {
		width: 15px;
		height: 15px;
		fill: #7e57c2;
		display: inline-block;
	}
	svg.disabled {
		fill: rgba(146, 116, 211, 0.3);
	}
</style>
